module.exports = __webpack_public_path__ + "img/Tessellate44.efa53ffa.jpg";